import { createAsyncThunk } from "@reduxjs/toolkit";
import { addTripMasterApiCall } from "../../Api/api";

export const addTripMasterAsync = createAsyncThunk(
   "tripMaster/add-trip",
   async ({ data, err, done }, thunkAPI) => {
      try {
         const response = await addTripMasterApiCall(data);

         if (response.data?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         err && err();
         return thunkAPI.rejectWithValue(error?.response?.data || "Something went wrong");
      }
   }
);
